import React, { useEffect, useRef, useState } from "react";
import PaginationComponent from "../../../../../biblio/Pagination/PaginationComponent";
import { Row } from "antd";
import DotsLoader from "../../../../../biblio/Loader/DotsLoader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../apis/store";
import { getDateRange, scroll } from "../../../../../components/utils/utils";
import { DonationAmountList } from "./DonationAmountList";
import { getDonationAmount } from "../../../../../apis/actions/recipient.actions";
import CustomConfigProvider from "../../../ProfileHeader";
const DonationAmountOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });

  const { DonationAmount, loading, TotalAmounts } = useSelector(
    (state: RootState) => state?.recipient
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [state]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getDonationAmount({
        limit: itemPerPage,
        page: currentPage,
        date_from: date_from,
        date_to: date_to,
      })
    );
  }, [dispatch, currentPage, state]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  return (
    <>
      <CustomConfigProvider
        title="التبرعات النقدية"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      />
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : DonationAmount?.length === 0 && state.year === "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد تبرعات
        </p>
      ) : DonationAmount?.length === 0 && state.year !== "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
           لا توجد تبرعات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <DonationAmountList amountDonation={DonationAmount} />
          </Row>
          <div className="takaful--pagination-container">
            {DonationAmount &&
              Math.ceil(TotalAmounts) * itemPerPage > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalAmounts) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default DonationAmountOverview;
